<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<onboarding-container [hideForward]="true" [displayProgressBar]="false" (back)="goBack()">
  <p class="zero-text p-huge-med">{{ 'onboarding.savings-plan.alternative.headline' | transloco }}</p>
  <div class="d-block d-sm-flex justify-content-between mt-4 mb-5">
    <ng-container *ngTemplateOutlet="savingsPlans; context: { items: etfs(), type: 'etfs' }" />
    <ng-container *ngTemplateOutlet="savingsPlans; context: { items: stocks(), type: 'stocks' }" />
  </div>
  <div class="zero-text p-big-bold mb-3">{{ 'onboarding.savings-plan.alternative.search' | transloco }}</div>
  <web-components-asset-search type="savings-plan-onboarding" (assetSelected)="addAsset($event)" />
</onboarding-container>

<ng-template #savingsPlans let-items="items" let-type="type">
  <div class="savings-plans-box">
    <div class="zero-text p-big-bold mb-1">{{ 'onboarding.savings-plan.alternative.' + type | transloco }}</div>
    @for (item of items; track $index) {
      <div class="d-flex justify-content-between align-items-center py-2" [class.border-bottom]="!$last">
        <div class="zero-text p-base-med truncate" [title]="item.name">{{ item.name }}</div>
        <web-design-system-icon-button
          [title]="'onboarding.savings-plan.alternative.title' | transloco"
          [routerLink]="[createSavingsPlanRoute, item.isin]"
          size="small"
          icon="pig"
          type="old-savings-plan"
        />
      </div>
    }
  </div>
</ng-template>
